import React, { PureComponent } from 'react'
import styles from './ConfirmDialog.scss'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

class ConfirmDialog extends PureComponent {
  static defaultProps = {
    className: '',
    sureButtonTitle: '確定',
    cancelButtonTitle: '取消',
    isShowSureButton: true,
    isShowCancelButton: true,
  }

  render() {
    const {
      onSure,
      onClose,
      title,
      content,
      sureButtonTitle,
      cancelButtonTitle,
      isShowCancelButton,
      isShowSureButton,
      className,
    } = this.props
    return (
      <Dialog
        className={`confirmDialog ${className}`}
        classes={{
          paper: 'confirmDialogPaperStyle',
        }}
        open={true}
        onClose={onClose}
      >
        <style jsx>{styles}</style>
        <DialogTitle>{title}</DialogTitle>
        {content && (
          <DialogContent>
            <DialogContentText>{content}</DialogContentText>
          </DialogContent>
        )}
        {(isShowSureButton || isShowCancelButton) && (
          <DialogActions>
            {isShowCancelButton && (
              <Button onClick={onClose} color="primary">
                {cancelButtonTitle}
              </Button>
            )}
            {isShowSureButton && (
              <Button onClick={onSure} color="primary">
                {sureButtonTitle}
              </Button>
            )}
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

export default ConfirmDialog
